import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { KindMiteilung } from '../../core/models/kind';
import { FormComponent } from '../../core/abstracts/components/form.component';
import { Mitteilung } from '../../core/models/mitteilung';
import { Pages } from 'src/app/core/routes/routes';
import { PiwikService } from 'src/app/shared/services/piwik';

@Component({
    selector: 'app-mitteilung-gesendet',
    templateUrl: './mitteilung-gesendet.component.html',
    styleUrls: ['./mitteilung-gesendet.component.scss'],
})
export class MitteilungGesendetComponent extends FormComponent implements OnInit {
    public filename = 'Veränderungsmitteilung.pdf';
    public mitteilung: Mitteilung;
    public kinderMitteilung: KindMiteilung[];
    @Output() neueAnfrage: EventEmitter<null> = new EventEmitter<null>();

    constructor(private injector: Injector, private matomo: PiwikService) {
        super(injector);
    }

    ngOnInit() {
        this.mitteilung = this.storeService.getData('mitteilung');
        this.kinderMitteilung = this.storeService.getData('kinderMitteilung');
        if (!this.mitteilung) {
            this.goToPage(Pages.VAEM);
        }
    }

    getUrl() {
        return this.buildUrl('file');
    }

    downloadFile() {
        this.matomo.trackEvent('runterladen', 'Veränderungsmitteilung herunterladen');
    }
}
